export default "__VITE_ASSET__2c126757__"